import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { PATH } from '../../../utils/Constants';
import whiteLogo from '../../../utils/images/bloomifai_logo.png';
import Badge from '@mui/material/Badge';
import { getUnreadCounts } from '../../action/Admin/CommonAction';
import { LanguageProvider, useLanguage } from '../../../utils/common/LanguageContext';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */

// HOC to inject language context into class component
const withLanguage = (Component) => {
    return (props) => {
        const { t } = useLanguage();
        return <Component {...props} t={t} />;
    };
};

class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            unReadMessageCount: 0,
            apiUnreadCount: 0,
        };
    }

    //componentDidMount
    componentDidMount() {
        this.getUnreadCounts();
    }

    //componentDidUpdate
    componentDidUpdate(prevProps) {
        if (prevProps.socketUnreadCount !== this.props.socketUnreadCount) {
            this.setState({
                unReadMessageCount: this.props.socketUnreadCount,
            });
        }
    }

    //getUnreadCounts
    getUnreadCounts = () => {
        this.props.getUnreadCounts((result) => {
            if (result && result.response) {
                const apiUnreadCount = result.response.unReadMessageCount;
                this.setState({
                    apiUnreadCount,
                    unReadMessageCount: apiUnreadCount,
                });
            }
        });
    };

    /**
     * Render page
     */
    render() {
        const { unReadMessageCount } = this.state;
        return (
            <div>
                <aside
                    className={`w-64 bg-UINavigation transition-all flex flex-col gap-8 xl:relative fixed h-full xl:left-0 z-20 ${
                        this.props.mobileNav ? 'left-0' : '-left-96'
                    }`}
                >
                    <div className="relative flex justify-center p-4">
                        <img src={whiteLogo} alt="VirtuOwl" className="relative h-16 w-26" />
                        <button
                            className="absolute block -right-8 xl:hidden"
                            onClick={() => {
                                this.props.onClickMobileNav(false);
                            }}
                        >
                            <i className="text-xl text-white far fa-times"></i>
                        </button>
                    </div>
                    <nav className="flex flex-col">
                        <Link
                            className={
                                this.props.active === PATH.IM_PHYSICIAN.DASHBOARD
                                    ? 'mdl-navigation__link items-center text-white p-4 font-normal flex gap-4 bg-light bg-opacity-10 rounded-lg mx-auto w-10/12'
                                    : 'items-center text-white p-4 font-normal flex gap-4 mx-auto w-10/12'
                            }
                            to={`${PATH.IM_PHYSICIAN.DASHBOARD}/${this.props.match.params.userId}`}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8 12V10"
                                    stroke="#F6F8FB"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M6.71334 1.87998L2.09334 5.57998C1.57334 5.99331 1.24 6.86665 1.35334 7.51998L2.24 12.8266C2.4 13.7733 3.30667 14.54 4.26667 14.54H11.7333C12.6867 14.54 13.6 13.7666 13.76 12.8266L14.6467 7.51998C14.7533 6.86665 14.42 5.99331 13.9067 5.57998L9.28667 1.88665C8.57334 1.31331 7.42 1.31331 6.71334 1.87998Z"
                                    stroke="#F6F8FB"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            {this.props.t('home')}
                        </Link>
                        {/* <Link
              className={
                this.props.active === PATH.IM_PHYSICIAN.MANAGE_SCHEDULE
                  ? "mdl-navigation__link items-center text-white p-4 font-normal flex gap-4 bg-light bg-opacity-10"
                  : "items-center text-white p-4 font-normal flex gap-4"
              }
              to={`${PATH.IM_PHYSICIAN.MANAGE_SCHEDULE}/${this.props.match.params.userId}`}
            >
              <i className="far fa-clock"></i> Manage Schedule
            </Link> */}
                        <Link
                            className={
                                this.props.active === PATH.IM_PHYSICIAN.APPOINTMENT
                                    ? 'mdl-navigation__link items-center text-white p-4 font-normal flex gap-4 bg-light bg-opacity-10 rounded-lg mx-auto w-10/12'
                                    : 'items-center text-white p-4 font-normal flex gap-4 mx-auto w-10/12'
                            }
                            to={`${PATH.IM_PHYSICIAN.APPOINTMENT}/${this.props.match.params.userId}`}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.33334 1.33325V3.33325"
                                    stroke="white"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M10.6667 1.33325V3.33325"
                                    stroke="white"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M2.33334 6.06006H13.6667"
                                    stroke="white"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M14 5.66659V11.3333C14 13.3333 13 14.6666 10.6667 14.6666H5.33333C3 14.6666 2 13.3333 2 11.3333V5.66659C2 3.66659 3 2.33325 5.33333 2.33325H10.6667C13 2.33325 14 3.66659 14 5.66659Z"
                                    stroke="white"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M10.4631 9.13338H10.4691"
                                    stroke="white"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M10.4631 11.1334H10.4691"
                                    stroke="white"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M7.997 9.13338H8.00299"
                                    stroke="white"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M7.997 11.1334H8.00299"
                                    stroke="white"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M5.52953 9.13338H5.53552"
                                    stroke="white"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M5.52953 11.1334H5.53552"
                                    stroke="white"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            {this.props.t('sessions')}
                        </Link>
                        <Link
                            className={
                                this.props.active === PATH.IM_PHYSICIAN.MY_STUDENTS
                                    ? 'mdl-navigation__link items-center text-white p-4 font-normal flex gap-3 bg-light bg-opacity-10 rounded-lg mx-auto w-10/12'
                                    : 'items-center text-white p-4 font-normal flex gap-4 mx-auto w-10/12'
                            }
                            to={`${PATH.IM_PHYSICIAN.MY_STUDENTS}/${this.props.match.params.userId}`}
                        >
                            {/* <img
                src={pic}
                alt="VirtuOwl"
                style={{
                  width: "16px",
                  height: "16px",
                }}
              /> */}
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.10668 7.24667C6.04001 7.24 5.96001 7.24 5.88668 7.24667C4.30001 7.19334 3.04001 5.89334 3.04001 4.29334C3.04001 2.66 4.36001 1.33334 6.00001 1.33334C7.63334 1.33334 8.96001 2.66 8.96001 4.29334C8.95334 5.89334 7.69334 7.19334 6.10668 7.24667Z"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M10.94 2.66666C12.2333 2.66666 13.2733 3.71333 13.2733 5C13.2733 6.26 12.2733 7.28666 11.0267 7.33333C10.9733 7.32666 10.9133 7.32666 10.8533 7.33333"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M2.77332 9.70666C1.15999 10.7867 1.15999 12.5467 2.77332 13.62C4.60666 14.8467 7.61332 14.8467 9.44666 13.62C11.06 12.54 11.06 10.78 9.44666 9.70666C7.61999 8.48666 4.61332 8.48666 2.77332 9.70666Z"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M12.2267 13.3333C12.7067 13.2333 13.16 13.04 13.5333 12.7533C14.5733 11.9733 14.5733 10.6867 13.5333 9.90667C13.1667 9.62667 12.72 9.44 12.2467 9.33334"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 256 256"
              >
                <path
                  fill="currentColor"
                  d="m225.9 58.31l-96-32a6 6 0 0 0-3.8 0l-96 32A6 6 0 0 0 26 64v80a6 6 0 0 0 12 0V72.32l38.68 12.9A62 62 0 0 0 99 174.75c-19.25 6.53-36 19.59-48 38a6 6 0 0 0 10 6.53C76.47 195.59 100.88 182 128 182s51.53 13.59 67 37.28a6 6 0 0 0 10-6.56c-12-18.38-28.73-31.44-48-38a62 62 0 0 0 22.27-89.53l46.63-15.5a6 6 0 0 0 0-11.38ZM178 120a50 50 0 1 1-89.37-30.8l37.47 12.49a6 6 0 0 0 3.8 0l37.47-12.49A49.78 49.78 0 0 1 178 120Zm-50-30.32L51 64l77-25.68L205 64Z"
                />
              </svg>{" "} */}
                            {this.props.t('team')}
                        </Link>
                        {/* {store.get("userSession").payoutEnabled && (
              <Link
                className={
                  this.props.active === PATH.IM_PHYSICIAN.FINANCIAL_REPORT
                    ? "mdl-navigation__link items-center text-white p-4 font-normal flex gap-4 bg-light bg-opacity-10"
                    : "items-center text-white p-4 font-normal flex gap-4"
                }
                to={`${PATH.IM_PHYSICIAN.FINANCIAL_REPORT}/${this.props.match.params.userId}`}
              >
                <i
                  className="fa-solid fa-money-bill-wave"
                  aria-hidden="true"
                ></i>{" "}
                Financial Reports
              </Link>
            )} */}
                        {/* <Link
                            className={
                                this.props.active === PATH.IM_PHYSICIAN.REFERRAL
                                    ? 'mdl-navigation__link items-center text-white p-4 font-normal flex gap-4 bg-light bg-opacity-10 rounded-lg mx-auto w-10/12'
                                    : 'items-center text-white p-4 font-normal flex gap-4 mx-auto w-10/12'
                            }
                            to={`${PATH.IM_PHYSICIAN.REFERRAL}/${this.props.match?.params.userId}`}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.16999 3.71002C5.05999 3.70002 4.93999 3.70002 4.82999 3.71002C4.39666 3.69669 3.98166 3.52335 3.67499 3.22669C3.36833 2.93002 3.19166 2.52669 3.17999 2.10002C3.17999 1.21002 3.89999 0.480019 4.79999 0.480019C5.68999 0.480019 6.41999 1.20002 6.41999 2.10002C6.41333 2.96335 5.80333 3.66335 5.16999 3.71002Z"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M9.15334 0.960022C9.87334 0.960022 10.46 1.55335 10.46 2.26669C10.46 2.96669 9.89334 3.54669 9.20001 3.57335C9.12001 3.56669 9.03334 3.56669 8.94667 3.57335"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M2.89333 5.85335C2.04 6.39335 2.04 7.29335 2.89333 7.82669C3.85333 8.43335 5.48 8.43335 6.44 7.82669C7.29333 7.28669 7.29333 6.38669 6.44 5.85335C5.48666 5.25335 3.85333 5.25335 2.89333 5.85335Z"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M10.2133 7.66669C10.4733 7.61335 10.74 7.60002 11.02 7.63335C11.6467 7.72002 12.22 8.04669 12.6 8.53335C13.1933 9.29335 13.1933 10.48 12.6 11.24C12.2267 11.72 11.6667 12.0467 11.0533 12.14"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M5.64 10.32H6.47334L4.97334 8.64002L3.47334 10.32H4.28667C4.28667 10.32 4.66 13.7467 8.94667 14.1867C7.54667 13.28 6.74 11.36 6.74 11.36"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            Referral
                        </Link> */}
                        <Link
                            className={
                                this.props.active === PATH.IM_PHYSICIAN.MESSAGES
                                    ? 'mdl-navigation__link items-center text-white p-4 font-normal flex gap-3 bg-light bg-opacity-10 rounded-lg mx-auto w-10/12'
                                    : 'items-center text-white p-4 font-normal flex gap-4 mx-auto w-10/12'
                            }
                            to={`${PATH.IM_PHYSICIAN.MESSAGES}/${this.props.match?.params.userId}`}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.3333 13.6666H4.66668C2.66668 13.6666 1.33334 12.6666 1.33334 10.3333V5.66659C1.33334 3.33325 2.66668 2.33325 4.66668 2.33325H11.3333C13.3333 2.33325 14.6667 3.33325 14.6667 5.66659V10.3333C14.6667 12.6666 13.3333 13.6666 11.3333 13.6666Z"
                                    stroke="white"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M11.3333 6L9.24665 7.66667C8.55999 8.21333 7.43332 8.21333 6.74665 7.66667L4.66666 6"
                                    stroke="white"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            {this.props.t('messages')}
                            {this.props.active !== PATH.IM_PHYSICIAN.MESSAGES && (
                                <Badge
                                    className="absolute right-[56%] bottom-3"
                                    badgeContent={unReadMessageCount}
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            backgroundColor: '#43a6b9',
                                            color: 'white',
                                        },
                                    }}
                                />
                            )}
                        </Link>
                    </nav>
                </aside>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    socketUnreadCount: state.UnreadReducerCount.unReadMessageCount,
});

const mapDispatchToProps = (dispatch) => {
    return {
        getUnreadCounts: (callback) => {
            dispatch(getUnreadCounts(callback));
        },
    };
};

const ConnectedNavigation = connect(mapStateToProps, mapDispatchToProps)(withLanguage(Navigation));

export default (props) => (
    <LanguageProvider>
        <ConnectedNavigation {...props} />
    </LanguageProvider>
);
